<template>
  <div
    class="settings-analyzer f-column"
    style="gap: 1rem"
    :class="{ gw_loading: loading }"
  >
    <!-- <div
      class="theme-block-title"
      v-if="hasTitle"
    >
      {{ $t('settings.solutions_hh_anlyzer') }}
    </div> -->
    <div
      v-if="hasTitle"
      class="theme-block-title"
    >
      {{ $t('settings.solutions_hh_anlyzer') }}
    </div>
    <div
      v-for="cat in [
        {
          format: 'Cash',
          boxes: [
            {
              title: 'Type', //
              key: 'type',
              options: conf.Cash.types,
              value: Cash.type,
            },
            {
              title: 'Rake',
              key: 'rake',
              options: conf.Cash.rakes,
              value: Cash.info.rake,
            },
          ],
        },
        {
          format: 'Spins',
          boxes: [
            {
              title: 'Type', //
              key: 'type',
              options: conf.Spins.types,
              value: Spins.type,
            },
            {
              title: 'With limps',
              key: 'with_limp',
              options: ['Yes', 'No'],
              value:
                Spins.info.with_limp === undefined ? 'none' : Spins.info.with_limp ? 'Yes' : 'No',
            },
          ],
        },
      ]"
      :key="cat.title"
      class="f-column position-relative"
      style="gap: 0.75rem; padding: 1rem; border: solid 1px var(--clr-black-2); border-radius: 8px"
    >
      <LoaderCircles
        v-if="updating[cat.format]"
        style="--size: 1rem; position: absolute; top: 1rem; right: 1rem"
      />

      <h3>{{ cat.format }}</h3>
      <div
        v-for="box in cat.boxes"
        :key="box.title"
        :class="{ 'no-events opacity_5': updating[cat.format] }"
        class="gw_box"
        style="--clr-box-back: rgba(255, 255, 255, 0.0325)"
      >
        <div class="text-medium weight_500 clr-grey">{{ box.title }}</div>
        <GwBtns
          class="gwbtns_horizontal_grey mt-1"
          btnClass="gw_loading_text"
          :options="box.options"
          :value="(box.value || '').toString()"
          @click="
            (_e, item) => {
              handleClick({ item, key: box.key, format: cat.format })
            }
          "
        >
          <template #default="{ item }">
            {{ item }}
          </template>
        </GwBtns>
      </div>
    </div>
  </div>
</template>

<script>
import GwBtns from '@/components/lib/GwBtns'
import LoaderCircles from '@/components/Loaders/LoaderCircles'

export default {
  name: 'SettingsAnalyzerV2',
  components: {
    GwBtns,
    LoaderCircles,
  },
  props: {
    hasTitle: { type: Boolean, default: true },
  },
  data() {
    this.conf = {
      Cash: {
        types: ['General', 'Simple'],
        rakes: ['NL50', 'NL500', 'GG NL50', 'GG NL500'],
      },
      Spins: {
        types: ['General', 'Simple'],
        with_limp: false,
      },
    }

    return {
      loading: false,
      updating: {
        Cash: false,
        Spins: false,
      },
      Cash: {
        format: 'Cash',
        public_id: undefined,
        type: undefined, // 'General',
        info: {
          rake: undefined, // 'NL50',
        },
      },
      Spins: {
        format: 'Spins',
        public_id: undefined,
        type: undefined, //
        info: {
          with_limp: undefined,
        },
      },
    }
  },
  created() {
    this.getSettings()
  },
  methods: {
    handleClick({ item, key, format }) {
      if (format === 'Cash') {
        this.Cash = {
          ...this.Cash,
          type: key === 'type' ? item : this.Cash.type || 'General',
          info: {
            rake: key === 'rake' ? item : this.Cash.rake || 'NL50',
          },
        }
        this.update({
          data: this.Cash, //
          format: 'Cash',
          public_id: this.Cash.public_id,
        })
      } else if (format === 'Spins') {
        this.Spins = {
          ...this.Spins,
          type: key === 'type' ? item : this.Spins.type || 'General',
          info: {
            with_limp: key === 'with_limp' ? item === 'Yes' : this.Spins.info.with_limp === 'Yes',
          },
        }
        this.update({
          data: this.Spins, //
          format: 'Spins',
          public_id: this.Spins.public_id,
        })
      }
    },
    async getSettings() {
      this.loading = true
      const result = await this.$store.dispatch('api_call', {
        endpoint: 'poker/preferred-format-types/',
        message: {
          type: 'error',
          status: 'error_fetching_preffered_gametype',
          statusMessages: {
            _error_fetching_preffered_gametype: {
              i18n: 'analyze.upload.error_fetching_preffered_gametype',
            },
          },
        },
      })
      this.loading = !!result.error
      const prefferedTypes = result.response?.data || []

      if (prefferedTypes) {
        const Cash = prefferedTypes.find(i => i.format === 'Cash')
        const Spins = prefferedTypes.find(i => i.format === 'Spins')
        this.Cash = Cash || this.Cash
        this.Spins = Spins || this.Spins
      }
      // this.updateGroups(prefferedTypes)
    },
    async update({ data, format, public_id }) {
      if (this.updating[format]) return
      this.updating[format] = true

      const result = await this.$store.dispatch('api_call', {
        endpoint: `poker/preferred-format-types${public_id ? `/${public_id}/` : '/'}`,
        method: public_id ? 'PATCH' : 'POST',
        message: {
          type: 'error',
          status: 'error_updating_preffered_gametype',
          statusMessages: {
            _error_updating_preffered_gametype: {
              i18n: 'analyze.upload.error_updating_preffered_gametype',
            },
          },
        },
        data,
      })
      this.updating[format] = false

      if (result.error) return
      const prefferedType = result.response?.data || []
      this[format] = prefferedType
    },
  },
  computed: {
    preference() {
      return [
        {
          format: 'Cash',
          // game_type_name: 'Cash6m500zBasic', // dont matter
          // public_id: 'string',
          info: {
            rake: this.Cash.rake,
          },
          type: this.Cash.rake,
        },
        {
          format: 'Spins',
          // game_type_name: null,
          // public_id: 'string',
          info: {
            with_limp: this.Spins.with_limp,
          },
          type: this.Spins.type,
        },
      ]
    },
  },
}
</script>
